module.exports = __webpack_public_path__ + "img/part-peek-desktop.e63d5847.jpg";